<div class="dialog">
  <div class="modal-body">
    <img *ngIf="isMatch" class="modal-body__image mt-4" src="../../../assets/icons/payment/checked.png" alt="Match" />
    <img *ngIf="isCloseMatch" class="modal-body__image mt-4" src="../../../assets/icons/payment/warning.png" alt="Close Match" />
    <img *ngIf="isNoMatch" class="modal-body__image mt-4" src="../../../assets/icons/payment/warning.png" alt="No Match" />
    <img *ngIf="!isMatch && !isCloseMatch && !isNoMatch" class="modal-body__image mt-4" src="../../../assets/icons/payment/warning.png" alt="Bank Details Not Valid" />
    <div class="modal-title mt-4 mb-4" [ngClass]="isMatch ? 'match' : ''">{{ title }}</div>
    <div class="modal-text mb-4" [innerHtml]="message"></div>
    <div>
      <button *ngIf="isMatch" class="modal-body__button-confirm button_green" (click)="continuePurchase()">
        <span>Continue</span>
        <img src="../../../assets/icons/buttons/arrowRight.png" alt="Continue">
      </button>
      <button *ngIf="isCloseMatch" class="modal-body__button-confirm button_whitered" (click)="continuePurchase()">
        <span>Continue anyway</span>
        <img src="../../../assets/icons/buttons/arrowRight-red.png" alt="Continue anyway">
      </button>
      <span *ngIf="isCloseMatch" class="modal-body__button-spacer"></span>
      <button *ngIf="isCloseMatch" class="modal-body__button-confirm button_green" (click)="updateNameAndContinue()">
        <span>Use bank record</span>
        <img src="../../../assets/icons/buttons/arrowRight.png" alt="Use bank record">
      </button>
      <button *ngIf="canEdit" class="modal-body__button-confirm button_green" (click)="stayOnPage()">
        <span>Edit details</span>
        <img src="../../assets/icons/buttons/arrowRight.png" alt="Edit">
      </button>
    </div>
    <div *ngIf="isNoMatch" class="secondRowOptions">
      <a (click)="continuePurchase()">Continue anyway</a>
    </div>
  </div>
</div>
